var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPermissions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.73608 2C6.59977 2 5.56098 2.64201 5.0528 3.65836L1.5528 10.6584C1.13051 11.5029 1.13051 12.4971 1.5528 13.3416L5.0528 20.3416C5.56098 21.358 6.59977 22 7.73608 22H12H16.2639C17.4003 22 18.4391 21.358 18.9472 20.3416L22.4472 13.3416C22.8695 12.4971 22.8695 11.5029 22.4472 10.6584L18.9472 3.65836C18.4391 2.64201 17.4003 2 16.2639 2H12H7.73608ZM6.84166 4.55279C7.01105 4.214 7.35731 4 7.73608 4H12H16.2639C16.6427 4 16.989 4.214 17.1584 4.55279L20.6584 11.5528C20.7991 11.8343 20.7991 12.1657 20.6584 12.4472L17.1584 19.4472C16.989 19.786 16.6427 20 16.2639 20H12H7.73608C7.35731 20 7.01105 19.786 6.84166 19.4472L3.34166 12.4472C3.20089 12.1657 3.20089 11.8343 3.34166 11.5528L6.84166 4.55279ZM9.00002 12C9.00002 10.3431 10.3432 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3432 15 9.00002 13.6569 9.00002 12ZM12 7C9.2386 7 7.00002 9.23858 7.00002 12C7.00002 14.7614 9.2386 17 12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissions);
export default __webpack_public_path__ + "static/media/permissions.84d773ed.svg";
export { ForwardRef as ReactComponent };